import { configureStore } from '@reduxjs/toolkit';
import customersReducer from './slices/customersSlice';
import projectsReducer from './slices/projectsSlice';
import searchReducer from './slices/searchSlice';
import dashboardReducer from './slices/dashboardSlice';
import ticketsReducer from './slices/ticketsSlice';
import knowledgeBaseReducer from './slices/knowledgeBaseSlice';
import tasksReducer from './slices/tasksSlice';
import usersReducer from './slices/usersSlice';

const store = configureStore({
  reducer: {
    customers: customersReducer,
    projects: projectsReducer,
    search: searchReducer,
    dashboard: dashboardReducer,
    tickets: ticketsReducer,
    knowledgeBase: knowledgeBaseReducer,
    tasks: tasksReducer,
    users: usersReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
